import React from 'react';

import { createHeaderCell } from '../../../../../../../../../../utils/tableUtil';

import CodeCell from './cells/CodeCell';
import InsurancePolicyCell from './cells/InsurancePolicyCell';
import InsuranceRequirementsCell from './cells/InsuranceRequirementsCell';
import PropertyCell from './cells/PropertyCell';
import UnitNumberCell from './cells/UnitNumberCell';
import ItemCodesHeaderTooltip from './components/ItemCodesHeaderTooltip';

export const generateItemsTableDefaultColumns = (companyId, insuredId) => [
  {
    header: createHeaderCell('Policy'),
    accessor: 'insurancePolicies',
    cell: InsurancePolicyCell,
    order: 0,
    disableSortBy: true,
    name: 'Policy'
  },
  {
    header: () => (<ItemCodesHeaderTooltip displayBulkUpdateTool companyId={companyId} insuredId={insuredId} />),
    accessor: 'codes',
    cell: CodeCell,
    order: 99,
    disableSortBy: true,
    name: 'Codes'
  },
  {
    header: createHeaderCell('Min. Req. Coverage'),
    accessor: 'insuranceRequirement',
    cell: InsuranceRequirementsCell,
    order: 100,
    disableSortBy: true,
    name: 'Min. Req. Coverage'
  }
];

export const buildItemColumns = itemTypeProperties => itemTypeProperties
  .filter(p => p.visibility !== 'hidden')
  .map(itemTypeProperty => ({
    id: itemTypeProperty.name,
    header: createHeaderCell(itemTypeProperty.displayName),
    accessor: item => item.properties?.find(itemProperty => itemProperty.name === itemTypeProperty.name),
    cell: ({ value: { value, dataType } = {}, row }) => {
      if (itemTypeProperty.name === 'unit_number') {
        return <UnitNumberCell row={row} values={{ value, dataType }} />;
      }

      return <PropertyCell dataType={dataType} value={value} />;
    },
    order: itemTypeProperty.order,
    sortKey: `property_values.${itemTypeProperty.name}.keyword`,
    name: itemTypeProperty.displayName
  }));
